import { useTheme } from '@emotion/react';
import { Box, Skeleton, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material';
import React from 'react';
import { useSelector } from 'react-redux';
import useStyles from '../../../booking-details/OnTripAnnouncement/styles';
import MainCard from 'ui-component/cards/MainCard';
import AddCouponsModal from './addCouponsModal';
import { ALLOCATEDCOUPONS_CONSTANTS, AVAILABLECOUPONS_CONSTANTS } from './constants';
import ViewHistoryModal from './viewHistoryModal';
import ShimmerCard from 'views/ui-elements/commons/shimmerCard';

const commonTableColumns = ['Coupon Name', 'Description', 'Validity', 'Travel Date', 'Product', 'Max Usage', ''];

const CounponsTable = ({
    tableData = [],
    isLoading = false,
    allocatedCouponsTable = false,
    handleButtonClick = () => {},
    openCouponsModal = false,
    setOpenCouponsModal = () => {},
    viewHistoryModal,
    setViewHistoryModal = () => {},
    orgCode,
    memberCode
}) => {
    const theme = useTheme();
    const classes = useStyles();
    const TabelHeader = () =>
        commonTableColumns?.map((columnName) => (
            <TableCell sx={{ minWidth: 120 }} className={classes.announcementCardHeadingText}>
                {columnName}
            </TableCell>
        ));
    const NoCouponsAvailable = () => {
        if (!tableData || tableData?.length <= 0) {
            return (
                <TableRow>
                    <TableCell tableCellClass={classes.tableCell} colSpan={commonTableColumns?.length}>
                        <Box sx={{ width: '100%', display: 'flex', justifyContent: 'center' }}>No coupons available</Box>
                    </TableCell>
                </TableRow>
            );
        }
        return <></>;
    };
    return (
        <>
            {isLoading ? (
                <ShimmerCard />
            ) : (
                <MainCard content={false}>
                    <TableContainer>
                        <Table sx={{ minWidth: 350 }} aria-label="simple table">
                            <TableHead>
                                <TableRow className={classes.primaryBackground}>
                                    <TabelHeader />
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {tableData?.length > 0 &&
                                    [...(tableData || [])]?.map((item, index) => (
                                        <TableRow
                                            style={{
                                                borderLeft: `0.5px solid ${theme.palette.grey[200]}`,
                                                borderTop: `0.5px solid ${theme.palette.grey[200]}`
                                            }}
                                            key={index}
                                        >
                                            <TableCell sx={{ minWidth: '100px' }}>
                                                <Typography className={classes.normalText}>{item?.couponName}</Typography>
                                            </TableCell>
                                            <TableCell sx={{ minWidth: '300px' }}>
                                                <Typography className={classes.normalText}>{item?.description}</Typography>
                                            </TableCell>
                                            <TableCell sx={{ minWidth: '200px' }}>
                                                <Typography className={classes.normalText}>{item?.validity}</Typography>
                                            </TableCell>
                                            <TableCell sx={{ minWidth: '200px' }}>
                                                <Typography className={classes.normalText}>{item?.travelDate}</Typography>
                                            </TableCell>
                                            <TableCell sx={{ minWidth: '200px' }}>
                                                <Typography className={classes.normalText}>{item?.product}</Typography>
                                            </TableCell>
                                            <TableCell sx={{ minWidth: '100px' }}>
                                                <Typography className={classes.normalText}>{item?.maxUsage}</Typography>
                                            </TableCell>
                                            <TableCell sx={{ minWidth: '100px' }}>
                                                <Typography
                                                    onClick={() =>
                                                        handleButtonClick({
                                                            item,
                                                            type: allocatedCouponsTable
                                                                ? ALLOCATEDCOUPONS_CONSTANTS
                                                                : AVAILABLECOUPONS_CONSTANTS
                                                        })
                                                    }
                                                    variant="body1"
                                                    color="primary"
                                                    style={{ cursor: 'pointer' }}
                                                    className={classes.smallLinkFont14}
                                                >
                                                    {allocatedCouponsTable ? 'View History' : 'Add Coupon'}
                                                </Typography>
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                <NoCouponsAvailable />
                            </TableBody>
                        </Table>
                    </TableContainer>
                    <AddCouponsModal
                        memberCode={memberCode}
                        orgCode={orgCode}
                        openCouponsModal={openCouponsModal}
                        setOpenCouponsModal={setOpenCouponsModal}
                    />
                    <ViewHistoryModal viewHistoryModal={viewHistoryModal} setViewHistoryModal={setViewHistoryModal} />
                </MainCard>
            )}
        </>
    );
};

export default CounponsTable;
